'use client';

import type { PropsWithChildren } from 'react';
import { PortalProvider } from '@cbhq/cds-web/overlays/PortalProvider';
import { ThemeProvider as CdsThemeProvider } from '@cbhq/cds-web/system';
import { defaultTheme } from '@cbhq/cds-web/themes/defaultTheme';

import { ToastProvider } from '../src/components/ui/Toast';
import { useTheme } from '../src/context/ThemeContext';

export function ClientLayout({ children }: PropsWithChildren) {
  const { resolvedTheme } = useTheme();

  return (
    <PortalProvider>
      <CdsThemeProvider theme={defaultTheme} activeColorScheme={resolvedTheme}>
        <ToastProvider>{children}</ToastProvider>
      </CdsThemeProvider>
    </PortalProvider>
  );
}
